import useGetSaleAgentsList from '../../../services/hookService/getSaleAgentsList/useGetSaleAgentsList';
import MainFooter from '../../../components/mazraeKit/footers/footerMain';
import CustomHeader from '../../../components/mazraeKit/headers/homeHeader';
import SaleAgentCard from '../../../components/mazraeKit/cards/saleAgentCard';
import {useParams} from 'react-router-dom';
import DotsLoading from '../../../components/dotsLoading';

export const SaleAgentsList = () => {
  const params = useParams();

  const {saleAgentList, isLoading} = useGetSaleAgentsList(
    params?.assigner_store as string,
  );

  return (
    <div className="flex flex-col gap-3 h-full">
      <CustomHeader title="عاملین فروش" preIcon="icon-nameArrow---Right" />
      {isLoading ? (
        <div className="flex h-full justify-center items-center">
          <DotsLoading />
        </div>
      ) : (
        <div className="flex flex-col h-full overflow-y-auto gap-3 p-3">
          {saleAgentList?.map(item => {
            return (
              <SaleAgentCard
                storeName={item.name}
                address={item.address}
                phone={item.phone_number}
              />
            );
          })}
        </div>
      )}

      <MainFooter />
    </div>
  );
};

export default SaleAgentsList;
